import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-65991a46"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "area-wrapper" }
const _hoisted_2 = { class: "show-area" }
const _hoisted_3 = {
  key: 0,
  class: "latest-select"
}
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "t" }, "上次选择", -1))
const _hoisted_5 = { class: "content" }
const _hoisted_6 = {
  key: 1,
  class: "select-content"
}
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "btn" }, "选择省", -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "line" }, null, -1))
const _hoisted_9 = { class: "content" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", null, "#", -1))
const _hoisted_11 = { class: "area-list" }
const _hoisted_12 = { class: "list" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "guide" }, "A-G", -1))
const _hoisted_14 = ["onClick"]
const _hoisted_15 = { class: "list" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "guide" }, "H-K", -1))
const _hoisted_17 = ["onClick"]
const _hoisted_18 = { class: "list" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "guide" }, "L-S", -1))
const _hoisted_20 = ["onClick"]
const _hoisted_21 = { class: "list" }
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "guide" }, "T-Z", -1))
const _hoisted_23 = ["onClick"]

import {
  ref,
  computed,
  onMounted,
  onBeforeMount,
} from "vue";
import areaList from "./areaList.json";


export default /*#__PURE__*/_defineComponent({
  __name: 'areaSelect-component',
  emits: ['changeArea'],
  setup(__props, { emit: $emit }) {

const dealedAreaList = ref(areaList.slice(1, areaList.length));
const nationWide = {
  value: -1,
  text: "全国",
  parentId: -1,
  order: 0,
};

const currentArea = ref(nationWide);
const financialArea = ref(nationWide);
const localArea = ref({})

const showAreas = ref(false);

const clickoutside = () => {
  showAreas.value = false;
};

const handleShowAreas = () => {
  showAreas.value = !showAreas.value;
};
const handleCloseArea = () => {
  showAreas.value = false;
  currentArea.value = financialArea.value;
};
// 地区选择
const handleSelectArea = (area) => {
  currentArea.value = area;
};
// 全国选择
const handleSelecAllArea = () => {
  currentArea.value = nationWide;
};
const handleConfirmSelect = () => {
  financialArea.value = currentArea.value
  // 缓存本地一份数据
  window.localStorage.setItem('selectArea', JSON.stringify(financialArea.value))
  localArea.value = {}
  $emit('changeArea', financialArea.value)
  showAreas.value = false;
}
// 上次使用
const handleUse = () => {
  currentArea.value = localArea.value
  handleConfirmSelect()
  localArea.value = {}
}
onMounted(() => {
  // 从本地取地区数据
  localArea.value = JSON.parse(window.localStorage.getItem('selectArea'))
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: "select",
      onClick: handleShowAreas
    }, [
      _createElementVNode("div", _hoisted_2, _toDisplayString(financialArea.value?.text), 1),
      _createElementVNode("i", {
        class: _normalizeClass(showAreas.value ? 'up' : 'down')
      }, null, 2)
    ]),
    (localArea.value && Object.keys(localArea.value).length > 0 && localArea.value.value != -1)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _hoisted_4,
          _createElementVNode("span", _hoisted_5, _toDisplayString(localArea.value?.text), 1),
          _createElementVNode("span", {
            onClick: handleUse,
            class: "use"
          }, "使用")
        ]))
      : _createCommentVNode("", true),
    (showAreas.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
          _createElementVNode("div", { class: "top" }, [
            _hoisted_7,
            _hoisted_8,
            _createElementVNode("div", {
              class: "close",
              onClick: handleCloseArea
            })
          ]),
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("div", {
              class: "all",
              onClick: handleSelecAllArea
            }, [
              _hoisted_10,
              _createElementVNode("span", {
                class: _normalizeClass(currentArea.value.value === -1 ? 'active' : '')
              }, "全国", 2)
            ]),
            _createElementVNode("div", _hoisted_11, [
              _createElementVNode("div", _hoisted_12, [
                _hoisted_13,
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(dealedAreaList.value.filter((area) => area.order === 1), (item) => {
                  return (_openBlock(), _createElementBlock("span", {
                    class: _normalizeClass(["item", item.value === currentArea.value.value ? 'active' : '']),
                    onClick: ($event: any) => (handleSelectArea(item)),
                    key: item.value
                  }, _toDisplayString(item.text), 11, _hoisted_14))
                }), 128))
              ]),
              _createElementVNode("div", _hoisted_15, [
                _hoisted_16,
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(dealedAreaList.value.filter((area) => area.order === 2), (item) => {
                  return (_openBlock(), _createElementBlock("span", {
                    class: _normalizeClass(["item", item.value === currentArea.value.value ? 'active' : '']),
                    onClick: ($event: any) => (handleSelectArea(item)),
                    key: item.value
                  }, _toDisplayString(item.text), 11, _hoisted_17))
                }), 128))
              ]),
              _createElementVNode("div", _hoisted_18, [
                _hoisted_19,
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(dealedAreaList.value.filter((area) => area.order === 3), (item) => {
                  return (_openBlock(), _createElementBlock("span", {
                    class: _normalizeClass(["item", item.value === currentArea.value.value ? 'active' : '']),
                    onClick: ($event: any) => (handleSelectArea(item)),
                    key: item.value
                  }, _toDisplayString(item.text), 11, _hoisted_20))
                }), 128))
              ]),
              _createElementVNode("div", _hoisted_21, [
                _hoisted_22,
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(dealedAreaList.value.filter((area) => area.order === 4), (item) => {
                  return (_openBlock(), _createElementBlock("span", {
                    class: _normalizeClass(["item", item.value === currentArea.value.value ? 'active' : '']),
                    onClick: ($event: any) => (handleSelectArea(item)),
                    key: item.value
                  }, _toDisplayString(item.text), 11, _hoisted_23))
                }), 128))
              ])
            ])
          ]),
          _createElementVNode("div", { class: "bottom" }, [
            _createElementVNode("div", {
              class: "btn",
              onClick: handleConfirmSelect
            }, "确认")
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})